import React from "react";


const SetARemind = () => {

  return (
    <>
    <style>
    {`
      @media (min-width: 992px) {
        #offcanvasSetAReminder {
          width: 30% !important;
        }
      }

      @media (min-width: 1200px) {
        #offcanvasSetAReminder {
          width: 15% !important;
        }
      }
    `}
  </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasSetAReminder"
        aria-labelledby="offcanvasSetAReminder"

      >
        <div className="offcanvas-header bg-primary">
          <h4 id="offcanvasSetProposalReminder" className="text-white">
            Set A Lead Reminder
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="mb-3 col-12">
              <label>Date</label>
              <input type="date" className="form-control"/> 
            </div>
            <div className="mb-3">
              <label className="form-label">Set Reminder To</label>
              <select className="form-select">
                <option>A</option>
                <option>B</option>
              </select>
            </div>
            <div className="mb-3 mt-1 col-12">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Description"
                      ></textarea>
                    </div>
            <div className="page-btn ">
              <button className="btn btn-primary page-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SetARemind;
